// extracted by mini-css-extract-plugin
export default {"wrapper":"ArticleContainer_wrapper__w3Glc","container":"ArticleContainer_container__-uc9L","headerTitle":"ArticleContainer_headerTitle__unfL5","main":"ArticleContainer_main__DlY4o"};